import { render, staticRenderFns } from "./BbForm.vue.html?vue&type=template&id=575652f6&"
import script from "./BbForm.component.js?vue&type=script&lang=vueJs&"
export * from "./BbForm.component.js?vue&type=script&lang=vueJs&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports